import React, { useEffect, useRef } from "react"
import style from "./EuleriagymBidimensionalBalanceChart.module.sass"
import { bidimensionalChart } from "../euleriagymBalanceCharts"

function EuleriagymBidimensionalBalanceChart(props) {
  const {
    axisTitles,
    clampedData,
    colors,
    data,
    enableLeft,
    enableRight,
    labels
  } = props

  const canvasWrapper = useRef(null)
  const chartInstance = useRef(null)

  useEffect(() => {
    renderChart()
  }, [clampedData, labels])

  useEffect(() => {
    updateChartColors()
  }, [enableLeft, enableRight])

  const getDatasets = (dataset) => {
    return dataset.map((item, index) => {
      return {
        data: item,
        borderColor: colors[index],
        backgroundColor: colors[index]
      }
    })
  }

  const renderChart = () => {
    if(canvasWrapper.current) {
      let canvas = canvasWrapper.current.querySelector("canvas")
      if(canvas) {
        canvas.remove()
      }
      canvas = document.createElement("canvas")
      canvasWrapper.current.appendChild(canvas)

      const datasets = getDatasets(clampedData)
      const tooltipDatasets = getDatasets(data)

      chartInstance.current = bidimensionalChart(canvas, datasets, labels, tooltipDatasets, axisTitles)
    }
  }

  const updateChartColors = () => {
    if(chartInstance.current && enableLeft != null && enableRight != null) {
      chartInstance.current.data.datasets.map((dataset, index) => {
        if (index == 0) {
          dataset.borderColor = enableLeft ? colors[index]: "rgba(255, 164, 17, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        } else {
          dataset.borderColor = enableRight ? colors[index] : "rgba(167, 120, 255, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        }
      })
      chartInstance.current.update()
    }
  }


  return (
    <div className={style.chartWrapper}>
      <div className={style.yUnit}>{`[cm]`}</div>
      <div className={style.xUnit}>{`[cm]`}</div>
      <div ref={canvasWrapper} className={style.canvasWrapper}></div>
    </div>
  )
}

export default EuleriagymBidimensionalBalanceChart